module.exports = __webpack_public_path__ + "static/media/mario_sokoban.ac5e8c43.png";